// Generated for @nava/participant-copy: where each text shows and what it allows. Edit the texts here; the
// participant app's locale files are not read at runtime.
/** Each text: its page, its longest length, and what it may and may not be. */
export const PARTICIPANT_COPY_TEXTS = [
    {
        key: 'landing.changeLanguage',
        page: 'everyPage',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'common.language',
        page: 'everyPage',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'common.talkInLanguages',
        page: 'everyPage',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'common.seeLanguages',
        page: 'everyPage',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'footer.poweredBy',
        page: 'everyPage',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'landing.heading',
        page: 'landing',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'landing.intro',
        page: 'landing',
        maxLength: 300,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'landing.continue',
        page: 'landing',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.title',
        page: 'start',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.checkInSubtitle',
        page: 'start',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.actions.expandItem',
        page: 'start',
        maxLength: 120,
        locked: false,
        control: true,
        vars: ['item'],
        fills: ['company'],
    },
    {
        key: 'preflight.microphone.title',
        page: 'start',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.microphone.checkInPrivacy',
        page: 'start',
        maxLength: 1000,
        locked: true,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.microphone.readMore',
        page: 'start',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.microphone.grantAccess',
        page: 'start',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.microphone.indicatorAction',
        page: 'start',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.microphone.accessGranted',
        page: 'start',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.microphone.errorHelper',
        page: 'start',
        maxLength: 300,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.microphone.browserNotSupported',
        page: 'start',
        maxLength: 300,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.terms.title',
        page: 'start',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.terms.checkInPrivacy',
        page: 'start',
        maxLength: 1000,
        locked: true,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.terms.readMore',
        page: 'start',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.terms.accept',
        page: 'start',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.terms.indicatorAction',
        page: 'start',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.terms.accepted',
        page: 'start',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.terms.rememberConsent',
        page: 'start',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.terms.rememberConsentCallTooltip',
        page: 'start',
        maxLength: 240,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'quickStart.agree',
        page: 'start',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'quickStart.back',
        page: 'start',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'quickStart.cancel',
        page: 'start',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.startCheckIn',
        page: 'start',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.preparingCheckIn',
        page: 'start',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.preparingCheckInDelayedTitle',
        page: 'start',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.preparingCheckInDelayedSubtitle',
        page: 'start',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.preparingCheckInLongSubtitleLineOne',
        page: 'start',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.preparingCheckInLongSubtitleLineTwo',
        page: 'start',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.checkInPreparationFailedTitle',
        page: 'start',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.checkInPreparationFailedMessage',
        page: 'start',
        maxLength: 300,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.retryPreparation',
        page: 'start',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.status.connecting',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.status.speaking',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.status.listening',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.status.thinking',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.question',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: false,
        vars: ['current', 'total'],
        fills: ['company'],
    },
    {
        key: 'interview.mainQuestion',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: false,
        vars: ['current', 'total'],
        fills: ['company'],
    },
    {
        key: 'interview.recording',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.endInterview',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.muteTooltip',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.unmuteTooltip',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.pauseTooltip',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.resumeTooltip',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.subtitleTooltip.show',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.subtitleTooltip.hide',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.toggleChat',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.toggleVoice',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.chatTooltip.type',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.chatTooltip.speak',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.chatTooltip.unavailable',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.chatDiscoveryHint',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.chatPlaceholder',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.sendMessage',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.chat.warmHeader',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.chat.newlineHint',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.chat.aiVoiceOn',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.chat.aiVoiceOff',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.chat.backToVoice',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.audio.controls',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.audio.callVolume',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.audio.muteSpeaker',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.audio.unmuteSpeaker',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.audio.microphone',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.audio.speaker',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.audio.device',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.audio.linkedRouting',
        page: 'conversation',
        maxLength: 300,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.audio.phoneSpeaker',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.audio.phoneEarpiece',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.audio.bluetoothHeadset',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.audio.wiredHeadset',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.audio.usbAudio',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.audio.systemDefault',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.audio.changeFailed',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.networkQuality.excellent',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.networkQuality.good',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.networkQuality.poor',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.networkQuality.bad',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.networkQuality.offline',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.pauseModal.title',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.pauseModal.timeRemaining',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: false,
        vars: ['time'],
        fills: ['company'],
    },
    {
        key: 'interview.pauseModal.timeoutWarning',
        page: 'conversation',
        maxLength: 300,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.pauseModal.resume',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.pauseModal.end',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.endConfirm.title',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.endConfirm.body',
        page: 'conversation',
        maxLength: 300,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.endConfirm.cancel',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'interview.endConfirm.end',
        page: 'conversation',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'complete.checkInTitle',
        page: 'thankYou',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'complete.checkInMessage',
        page: 'thankYou',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'studyClosed.checkInTitle',
        page: 'closed',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'studyClosed.checkInMessage',
        page: 'closed',
        maxLength: 300,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'studyNotOpen.checkInTitle',
        page: 'closed',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'studyNotOpen.checkInMessage',
        page: 'closed',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'studyNotReady.checkInTitle',
        page: 'closed',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'studyNotReady.checkInMessage',
        page: 'closed',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'participantLinkCompleted.checkInTitle',
        page: 'closed',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'participantLinkCompleted.checkInMessage',
        page: 'closed',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'loading.interview',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'browserHelp.title',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'browserHelp.description',
        page: 'help',
        maxLength: 300,
        locked: false,
        control: false,
        vars: ['browserOptions'],
        fills: ['company'],
    },
    {
        key: 'browserHelp.namedDescription',
        page: 'help',
        maxLength: 1000,
        locked: false,
        control: false,
        vars: ['app', 'browserOptions'],
        fills: ['company'],
    },
    {
        key: 'browserHelp.appleBrowsers',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'browserHelp.windowsBrowsers',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'browserHelp.otherBrowsers',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'browserHelp.openSafari',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'browserHelp.copyLink',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'browserHelp.copied',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'browserHelp.manualCopy',
        page: 'help',
        maxLength: 300,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'browserHelp.copyInstructions',
        page: 'help',
        maxLength: 1000,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'browserHelp.linkLabel',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'browserHelp.continueAnyway',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.microphone.recovery.denied',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.microphone.recovery.timedOut',
        page: 'help',
        maxLength: 300,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.microphone.recovery.notFound',
        page: 'help',
        maxLength: 300,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.microphone.recovery.notReadable',
        page: 'help',
        maxLength: 300,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.microphone.recovery.failed',
        page: 'help',
        maxLength: 300,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.microphone.recovery.retry',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.microphone.recovery.close',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.microphone.recovery.helpTitle',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.microphone.recovery.helpDescription',
        page: 'help',
        maxLength: 1000,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.microphone.recovery.safariMacSettings',
        page: 'help',
        maxLength: 300,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.microphone.recovery.chromiumSettings',
        page: 'help',
        maxLength: 300,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.microphone.recovery.siteSettings',
        page: 'help',
        maxLength: 300,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.microphone.recovery.allowMicrophone',
        page: 'help',
        maxLength: 1000,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'preflight.microphone.recovery.deviceSettings',
        page: 'help',
        maxLength: 300,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'microphoneQuality.title',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'microphoneQuality.instructions',
        page: 'help',
        maxLength: 300,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'microphoneQuality.recoveryMessage',
        page: 'help',
        maxLength: 1000,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'microphoneQuality.poor',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'microphoneQuality.almostThere',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'microphoneQuality.perfect',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'microphoneQuality.waiting',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'microphoneQuality.from',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'microphoneQuality.defaultDevice',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'microphoneQuality.helpText',
        page: 'help',
        maxLength: 300,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'microphoneQuality.done',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'startupRecovery.title',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'startupRecovery.failed',
        page: 'help',
        maxLength: 300,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'startupRecovery.timedOut',
        page: 'help',
        maxLength: 300,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'startupRecovery.cancelled',
        page: 'help',
        maxLength: 300,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'startupRecovery.microphone',
        page: 'help',
        maxLength: 300,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'startupRecovery.delayed',
        page: 'help',
        maxLength: 300,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'startupRecovery.retry',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'startupRecovery.support',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'startupRecovery.copy',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'startupRecovery.copied',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'startupRecovery.checking',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'startupRecovery.unavailable',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'startupRecovery.advice',
        page: 'help',
        maxLength: 1000,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'startupRecovery.checkAgain',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'connectionDetails.quality',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'connectionDetails.excellent',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'connectionDetails.good',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'connectionDetails.poor',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'connectionDetails.bad',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'connectionDetails.offline',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'connectionDetails.notChecked',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'connectionDetails.lastChecked',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'connectionDetails.warning',
        page: 'help',
        maxLength: 300,
        locked: false,
        control: false,
        vars: ['services'],
        fills: ['company'],
    },
    {
        key: 'connectionDetails.navaApi',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'connectionDetails.interviewApi',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'connectionDetails.ok',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'connectionDetails.refresh',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'connectionDetails.success',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'connection.error',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'connection.errorDefault',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'connection.retry',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'versionRefresh.message',
        page: 'help',
        maxLength: 300,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'versionRefresh.action',
        page: 'help',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'cookies.banner.title',
        page: 'cookies',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'cookies.banner.message',
        page: 'cookies',
        maxLength: 1000,
        locked: true,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'cookies.banner.privacyPolicy',
        page: 'cookies',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'cookies.banner.acceptAll',
        page: 'cookies',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'cookies.banner.managePreferences',
        page: 'cookies',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'cookies.modal.title',
        page: 'cookies',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'cookies.modal.description',
        page: 'cookies',
        maxLength: 1000,
        locked: true,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'cookies.modal.readMore',
        page: 'cookies',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'cookies.modal.save',
        page: 'cookies',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'cookies.modal.close',
        page: 'cookies',
        maxLength: 120,
        locked: false,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'cookies.modal.essential.title',
        page: 'cookies',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'cookies.modal.essential.description',
        page: 'cookies',
        maxLength: 300,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'cookies.modal.analytics.title',
        page: 'cookies',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'cookies.modal.analytics.description',
        page: 'cookies',
        maxLength: 300,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'invitation.subject',
        page: 'invitation',
        maxLength: 120,
        locked: true,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'invitation.greeting',
        page: 'invitation',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company', 'name'],
    },
    {
        key: 'invitation.body',
        page: 'invitation',
        maxLength: 300,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'invitation.aiNotice',
        page: 'invitation',
        maxLength: 1000,
        locked: true,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'invitation.button',
        page: 'invitation',
        maxLength: 120,
        locked: true,
        control: true,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'invitation.fallbackLink',
        page: 'invitation',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'invitation.footer',
        page: 'invitation',
        maxLength: 300,
        locked: true,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'invitation.optOut',
        page: 'invitation',
        maxLength: 120,
        locked: true,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'sms.invite',
        page: 'invitation',
        maxLength: 120,
        locked: false,
        control: false,
        vars: [],
        fills: ['company'],
    },
    {
        key: 'sms.stop',
        page: 'invitation',
        maxLength: 120,
        locked: true,
        control: false,
        vars: [],
        fills: ['company'],
    },
];
//# sourceMappingURL=PARTICIPANT_COPY_TEXTS.js.map